<template>
  <div>
    <nested-info-card
      :title="EmploymentTitle"
      :data="employmentHistories"
      :get_error="get_error"
      :setShowAddHistory="setShowAddHistory"
      :itemIndex="1"
      :reload="reload"
      :handleDeleteButtonClick="handleDeleteButtonClick"
      :del_success="del_success"
      :del_error="del_error"
      :handleEditButtonClick="handleEditButtonClick"
    ></nested-info-card>
    <nested-info-card
      :title="EducationTitle"
      :data="educationHistories"
      :get_error="get_error"
      :setShowAddHistory="setShowAddHistory"
      :itemIndex="2"
      :reload="reload"
      :handleDeleteButtonClick="handleDeleteButtonClick"
      :del_success="del_success"
      :del_error="del_error"
      :handleEditButtonClick="handleEditButtonClick"
    ></nested-info-card>
    <AddEmploymentHistory
      :showAddEmploymentHistory="showAddEmploymentHistory"
      :close="close"
      :reload="reload"
    >
    </AddEmploymentHistory>
    <AddEducationHistory
      :showAddEducationHistory="showAddEducationHistory"
      :close="close"
      :reload="reload"
    >
    </AddEducationHistory>
    <EditEmploymentHistory
      :info="historyInfoToEdit"
      :showEditInfo="showEditEmploymentInfo"
      :close="closeForm"
      :reload="reload"
    >
    </EditEmploymentHistory>
    <EditEducationHistory
      :info="historyInfoToEdit"
      :showEditInfo="showEditEducationHistory"
      :close="closeForm"
      :reload="reload"
      :setshowEditInfo="setshowEditInfo"
    >
    </EditEducationHistory>
    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import AddEmploymentHistory from '@/components/employees/modals/addEmploymentHistory.vue';
import AddEducationHistory from '@/components/employees/modals/addEducationHistory.vue';
import EditEmploymentHistory from '@/components/employees/modals/editEmploymentHistory.vue';
import EditEducationHistory from '@/components/employees/modals/editEducationHistory.vue';
import ActionWarning from '@/utils/actionWarning.vue';
import axios from 'axios';
import NestedInfoCard from '../nestedInfoCard.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'EmployementAndEducation',
  components: {
    NestedInfoCard,
    AddEmploymentHistory,
    ActionWarning,
    EditEmploymentHistory,
    EditEducationHistory,
    AddEducationHistory,
  },
  data() {
    return {
      EmploymentTitle: 'Employment History',
      EducationTitle: 'Education',
      showAddEmploymentHistory: false,
      employmentAndEducationHistory: [],
      employmentHistories: [],
      educationHistories: [],
      employmentHistory: [],
      educationHistory: [],
      get_error: null,
      title: '',
      message: '',
      historyToDelete: null,
      showWarning: false,
      del_success: null,
      del_error: null,
      historyInfoToEdit: null,
      showEditEmploymentInfo: false,
      showEditEducationHistory: false,
      showAddEducationHistory: false,
      indexItemTodelete: null,
      empId: '',
    };
  },
  computed: {
    ...mapGetters([
      'getOrganization',
      'getToken',
      'getCurrentEmployeeId',
      'getUserToView',
      'getUser',
    ]),
  },
  created() {
    // Retrieve the employeeId from localStorage
    this.empId = localStorage.getItem('selectedEmployeeId');

    if (this.empId) {
      this.getEmploymentAndEducationHistory(this.empId);
    } else {
      this.empId = this.getCurrentEmployeeId;
    }
  },

  methods: {
    setShowAddHistory(index) {
      // console.log(index);
      if (index === 1) {
        this.showAddEmploymentHistory = true;
      } else {
        this.showAddEducationHistory = true;
      }
    },

    close() {
      this.showAddEmploymentHistory = false;
      this.showAddEducationHistory = false;
    },
    closeForm() {
      this.showEditEmploymentInfo = false;
      this.showEditEducationHistory = false;
    },
    reload() {
      this.showAddEmploymentHistory = false;
      this.showEditEmploymentInfo = false;
      this.showEditEducationHistory = false;
      this.getEmploymentAndEducationHistory(this.empId);
    },
    // /{organization}/employee/employement/history/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .post(
          `${this.getOrganization}/employee/employement/history/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit('closeOnSuccess', response.data.StatusMessage);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    // /{organization}/employee/employment/education/history/{employeeId}/v1/request
    getEmploymentAndEducationHistory(empId) {
      console.log(empId);
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/employment/education/history/${empId}/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              console.log(response.data.Data);
              this.employmentAndEducationHistory = response.data.Data;
              this.employmentHistory = response.data.Data.employmentHistories;
              this.educationHistory = response.data.Data.educationHistories;
              this.educationHistories = response.data.Data.educationHistories;
              console.log(this.educationHistories);
              this.employmentHistories = response.data.Data.employmentHistories;
            } else {
              setTimeout(() => {
                this.get_error = response.data.StatusMessage;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            setTimeout(() => {
              this.get_error = error.message;
            }, 2500);
          }
        );
    },

    setshowEditInfo() {
      this.showAddEducationHistory = false;
    },

    setIsConfirmed() {
      this.showWarning = false;
      this.deleteEmploymentAndEducationHistory(
        this.historyToDelete,
        this.indexItemTodelete
      );
    },

    handleEditButtonClick(info, index) {
      if (index === 1) {
        this.historyInfoToEdit = info;

        this.showEditEmploymentInfo = true;
      } else {
        this.historyInfoToEdit = info;

        this.showEditEducationHistory = true;
      }
    },

    handleDeleteButtonClick(info, index) {
      // Handle the button click for the delete button

      //console.log(info)
      this.title = `Delete history for ${
        index === 1 ? info.OrganizationName : info.InstitutionName
      }`;
      this.message = `You are about to delete ${
        index === 1 ? info.OrganizationName : info.InstitutionName
      } at ${
        index === 1 ? info.OrganizationName : info.InstitutionName
      } from your ${index === 1 ? 'employment' : 'education'} histories!`;
      this.historyToDelete = info;
      this.indexItemTodelete = index;
      this.showWarning = true;
    },

    // /{organization}/employee/employment/history/{employmentHistoryId}/v1/delete
    deleteEmploymentAndEducationHistory(history, itemIndex) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      if (itemIndex === 1) {
        axios
          .delete(
            `${this.getOrganization}/employee/employment/history/${history.EmploymentHistoryId}/v1/delete`,
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.del_success = response.data.StatusMessage;
                this.reload();
                setTimeout(() => {
                  this.del_success = null;
                }, 2500);
              } else {
                this.del_error = response.data.StatusMessage;
              }
            },
            (error) => {
              this.loading = false;
              this.del_error = error.message;
            }
          );
      } else {
        axios
          .delete(
            `${this.getOrganization}/employee/education/history/${history.EducationHistoryId}/v1/delete`,
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.del_success = response.data.StatusMessage;
                this.reload();
                setTimeout(() => {
                  this.del_success = null;
                }, 2500);
              } else {
                this.del_error = response.data.StatusMessage;
              }
            },
            (error) => {
              this.loading = false;
              this.del_error = error.message;
            }
          );
      }
    },
  },
};
</script>
